export default "__VITE_ASSET__3ea46936__"